import 'hanf/anchor'
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"

Rails.start()
Turbolinks.start()

import 'bootstrap'
import 'bootstrap4-toggle/js/bootstrap4-toggle.min'
import 'bootstrap-select/js/bootstrap-select'

import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("controllers", true, /.js$/)
application.load(definitionsFromContext(context))

document.addEventListener('turbolinks:load', function () {
  document.querySelectorAll('.anchorjs-link').forEach((link) => {
    link.setAttribute('data-turbolinks', false)
  })
  document.querySelectorAll('.article nav a').forEach((link) => {
    link.setAttribute('data-turbolinks', false)
  })
  let content = $('body');
  let spy = content.scrollspy({target: '#navbar-canna', offset: 30});

  // DOC: https://stackoverflow.com/questions/48693913/bootstrap-4-activate-bs-scrollspy-event-is-not-firing
  $(window).on('activate.bs.scrollspy',function(e, obj) {
  });
});
